'use strict';

var TextEncoder = global.TextEncoder ? global.TextEncoder // browser
: require('text-encoding').TextEncoder; // node shim
module.exports = TextEncoder;


//////////////////
// WEBPACK FOOTER
// ./~/@trust/jwa/lib/text-encoder/index.js
// module id = 4
// module chunks = 0